import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/whatsapp";
import { useLang } from "@/lib/i18n";

export default function WhatsAppFab() {
  const { t } = useLang();
  return (
    <a
      href={buildWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={t("form.whatsapp_book")}
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 pl-3 pr-5 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-[0_8px_28px_rgba(37,211,102,0.45)] hover:shadow-[0_10px_36px_rgba(37,211,102,0.6)] transition-all duration-300"
    >
      <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
        <MessageCircle className="w-5 h-5 stroke-[2.25]" />
      </span>
      <span className="hidden sm:inline text-sm font-semibold tracking-wide">{t("form.whatsapp_book")}</span>
    </a>
  );
}
